import { Injectable } from '@angular/core';
import { ModalSize } from '../../services/smart-modal.service';
import { DialogModalSize } from '../dialog/dialog-ref';

@Injectable()
export class EditableGridWithBannerService {
  constructor(

  ) {

  }


  checktableHeaderWidth(column) { //{'width': th.component =='inputSearch'? 300+'px':'auto'}
    if (column != undefined && column.hasOwnProperty('component')) {
      switch (column.component) {
        case 'inputSearch': {
          return '270px';
        }
        case 'dropdown': {
          if (column.label.length < 5) {
            return '90px';
          } else {
            return 'auto';
          }
        }
        case 'textbox': {
          if (column.type === 'number') {
            return '80px';
          } else {
            return 'auto';
          }
        }
      }
    }

  }
  checkingModalSize(size?: string) { // check modal size before open popup
    switch (size) {
      case 'sm':
        return ModalSize.Sm
        break;

      case 'md':
        return ModalSize.Md
        break;

      case 'lg':
        return ModalSize.Lg
        break;

      case 'xl':
        return ModalSize.Xl
        break;

      case 'xxl':
        return ModalSize.XXl
        break;

      default:
        return ModalSize.Md
        break;

    }
  }


  checkingDialogModalSize(size?: string) { // check modal size before open popup
    switch (size) {
      case 'sm':
        return DialogModalSize.Sm
        break;

      case 'md':
        return DialogModalSize.Md
        break;

      case 'lg':
        return DialogModalSize.Lg
        break;

      case 'xl':
        return DialogModalSize.Xl
        break;

      case 'xxl':
        return DialogModalSize.XXl
        break;

      default:
        return DialogModalSize.Md
        break;

    }
  }


}

